import { ReactComponent as InsuranceIconSvg } from '../../../assets/menu/icon-insurance.svg';
import SidebarItem from '../../shared/sidebar/sidebar-item';

export type KayNButtonProps = {
  to: string;
  isActive?: boolean;
  onClick?: () => void;
};

const KayNButton = ({ to, isActive, onClick }: KayNButtonProps) => {
  return (
    <SidebarItem title="Insurance" onClick={onClick} to={to} isActive={isActive}>
      <InsuranceIconSvg style={{ width: '24px', height: '24px' }} />
    </SidebarItem>
  );
};

export default KayNButton;
